module.exports = __webpack_public_path__ + "229212bc6a36c72b5e110b0f94d64fd9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-16.png
// module id = 2967
// module chunks = 0